<template>
  <div class="help-page">
    <div class="mobile-tab-selector" @click="showMobileMenu = !showMobileMenu">
      <span>{{ getCurrentTab }}</span>
      <i :class="['el-icon-arrow-down', {'el-icon-arrow-up': showMobileMenu}]"></i>
    </div>
    <div class="help-menu" :class="{'mobile-menu-active': showMobileMenu}">
      <router-link to="/help/how-to-play" class="menu-item" :class="{ active: $route.path === '/help/how-to-play' }" @click="closeMobileMenu">How to play</router-link>
      <router-link to="/help/how-to-claim-prizes" class="menu-item" :class="{ active: $route.path === '/help/how-to-claim-prizes' }" @click="closeMobileMenu">How to claim prizes</router-link>
    </div>
    <div class="help-content">
      <div v-if="$route.path === '/help/how-to-play'">
        <h1>How to Play</h1>

        <p>Learn more about how to play your favorite Lucky Lottery games by selecting a game from the menu on the left. Find information on game rules, entry types, and chances of winning.</p>

        <div class="game-selection">
          <router-link to="/games/lucky-ball-5" class="game-card">
            <img :src="require('../assets/images/ball5_new.png')" alt="Lucky 5 Ball">
            <h3>Lucky 5 Ball</h3>
          </router-link>

          <router-link to="/games/lucky-ball-8" class="game-card">
            <img :src="require('../assets/images/ball8.png')" alt="Lucky 8 Ball">
            <h3>Lucky 8 Ball</h3>
          </router-link>

          <router-link to="/games/lucky-ball-10" class="game-card">
            <img :src="require('../assets/images/ball10.png')" alt="Lucky 10 Ball">
            <h3>Lucky 10 Ball</h3>
          </router-link>

          <router-link to="/games/lucky-ball-20" class="game-card">
            <img :src="require('../assets/images/ball20.png')" alt="Lucky 20 Ball">
            <h3>Lucky 20 Ball</h3>
          </router-link>
        </div>

        <div class="general-help">
          <h2>General Information</h2>
          <div class="help-section">
            <h3>Purchasing Tickets</h3>
            <p>Tickets can be purchased from any authorized Lucky Lottery retailer. Simply ask the retailer for your desired game and select your numbers, or opt for a Quick Pick where numbers are randomly generated for you.</p>
          </div>

          <div class="help-section">
            <h3>Checking Results</h3>
            <p>Results for all games are posted on this website shortly after each draw. You can also check your tickets at any authorized retailer or by using the Lucky Lottery mobile app.</p>
          </div>

          <div class="help-section">
            <h3>Need More Help?</h3>
            <p>If you need further assistance, please contact our customer support team:</p>
            <ul>
              <li>Phone: 1300 123 456</li>
              <li>Email: support@luckylottery.com</li>
              <li>Live Chat: Available on our website during business hours</li>
            </ul>
          </div>
        </div>

        <div class="help-banner">
          <img :src="require('../assets/images/help-banner_new.png')" alt="Help">
        </div>
      </div>

      <div v-if="$route.path === '/help/how-to-claim-prizes'">
        <h1>How to Claim Prizes</h1>

        <p>Congratulations on your win! Here's information on how to claim your prize. The claim process depends on the amount you've won and your location.</p>

        <div class="prize-categories">
          <div class="prize-category">
            <h3>Small Prizes (Up to $1,500)</h3>
            <div class="prize-details">
              <p>For prizes of $1,500 or less, you can visit any authorized Lucky Lottery retailer. Simply present your winning ticket to the retailer, and they will process the cash payment.</p>
              <p><strong>What you need:</strong> Winning ticket</p>
              <p><strong>Claim time:</strong> Immediate</p>
            </div>
          </div>

          <div class="prize-category">
            <h3>Medium Prizes ($1,501 - $25,000)</h3>
            <div class="prize-details">
              <p>For prizes between $1,501 and $25,000, you'll need to visit a Lucky Lottery regional office. These offices are located in each major city and can process your prize via check or bank transfer.</p>
              <p><strong>What you need:</strong> Winning ticket, ID, bank account details</p>
              <p><strong>Claim time:</strong> Usually same day, approximately 1-2 hours</p>
            </div>
          </div>

          <div class="prize-category">
            <h3>Major Prizes ($25,001+)</h3>
            <div class="prize-details">
              <p>For prizes over $25,000, you'll need to visit the main Lucky Lottery headquarters. An appointment is recommended for security purposes.</p>
              <p><strong>What you need:</strong> Winning ticket, multiple forms of ID, tax documents, bank account details</p>
              <p><strong>Claim time:</strong> Processing typically takes 2-5 business days</p>
            </div>
          </div>
        </div>

        <div class="important-notes">
          <h2>Important Notes</h2>
          <ul>
            <li>All prizes must be claimed within 6 months from the draw date</li>
            <li>Damaged or illegible tickets may require verification procedures</li>
            <li>Prizes over $10,000 may be subject to tax</li>
            <li>Keep your winning ticket safe - treat it as cash</li>
          </ul>
        </div>

        <div class="contact-support">
          <h2>Need Help?</h2>
          <p>If you have any questions about claiming your prize, please contact our prize claims specialists:</p>
          <div class="contact-details">
            <div class="contact-method">
              <h3>Phone</h3>
              <p>1300 555 789</p>
            </div>
            <div class="contact-method">
              <h3>Email</h3>
              <p>prizes@luckylottery.com</p>
            </div>
            <div class="contact-method">
              <h3>Hours</h3>
              <p>Monday to Friday: 9am to 5pm</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Help',
  data() {
    return {
      showMobileMenu: false
    }
  },
  computed: {
    getCurrentTab() {
      return this.$route.path === '/help/how-to-play' ? 'How to play' : 'How to claim prizes';
    }
  },
  methods: {
    closeMobileMenu() {
      this.showMobileMenu = false;
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(newPath) {
        // If path doesn't match any known path, redirect to default path
        if(newPath !== '/help/how-to-play' && newPath !== '/help/how-to-claim-prizes') {
          this.$router.push('/help/how-to-play');
        }
      }
    }
  }
}
</script>

<style scoped>
.help-page {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 30px;
  box-sizing: border-box;
}

.mobile-tab-selector {
  display: none;
  padding: 15px;
  background-color: #ff69b4;
  color: white;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 15px;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 5px rgba(255, 105, 180, 0.3);
}

.help-menu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-item {
  padding: 10px;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  border-radius: 4px;
  transition: all 0.3s;
}

.menu-item:hover,
.menu-item.active {
  background-color: #ff69b4;
  color: white;
}

.help-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
}

.help-content h1 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}

.help-content h2 {
  font-size: 20px;
  color: #333;
  margin: 30px 0 15px;
}

.help-content h3 {
  font-size: 18px;
  color: #333;
  margin: 15px 0 10px;
}

.help-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.game-selection {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 30px;
}

.game-card {
  text-decoration: none;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s;
}

.game-card:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-color: #ff69b4;
}

.game-card img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.game-card h3 {
  color: #333;
  font-size: 16px;
}

.general-help {
  margin-top: 40px;
  border-top: 2px solid #f5f5f5;
  padding-top: 20px;
}

.help-section {
  margin-bottom: 30px;
}

.help-section:last-child {
  margin-bottom: 0;
}

.help-section ul {
  list-style-type: disc;
  margin-left: 20px;
  color: #666;
}

.help-section li {
  margin-bottom: 5px;
}

/* Added styles */
.prize-categories {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.prize-category {
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
}

.prize-category h3 {
  background-color: #ff69b4;
  color: white;
  margin: 0;
  padding: 12px 15px;
  font-size: 18px;
}

.prize-details {
  padding: 15px;
}

.prize-details p {
  margin-bottom: 10px;
}

.prize-details p:last-child {
  margin-bottom: 0;
}

.important-notes {
  margin-top: 30px;
  padding: 15px;
  background-color: #fff8f8;
  border-radius: 8px;
  border-left: 4px solid #ff69b4;
}

.important-notes ul {
  list-style-type: square;
  margin-left: 20px;
  color: #666;
}

.important-notes li {
  margin-bottom: 10px;
}

.contact-support {
  margin-top: 30px;
}

.contact-details {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 15px;
}

.contact-method {
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  text-align: center;
}

.contact-method h3 {
  margin-top: 0;
  color: #ff69b4;
}

.contact-method p {
  margin-bottom: 0;
}

.help-banner img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .help-page {
    grid-template-columns: 1fr;
    padding: 15px;
    gap: 15px;
  }
  
  .mobile-tab-selector {
    display: flex;
  }
  
  .help-menu {
    display: none;
    position: absolute;
    z-index: 10;
    background: white;
    width: calc(100% - 30px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    border-radius: 4px;
    margin-top: -10px;
  }
  
  .help-menu.mobile-menu-active {
    display: flex;
  }
  
  .help-content {
    padding: 20px 15px;
  }
  
  .game-selection {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .contact-details {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 576px) {
  .help-page {
    padding: 10px;
  }
  
  .help-content {
    padding: 15px 10px;
  }
  
  .game-selection {
    grid-template-columns: 1fr;
  }
  
  .help-content h1 {
    font-size: 22px;
  }
  
  .help-content h2 {
    font-size: 18px;
  }
  
  .help-content h3 {
    font-size: 16px;
  }
  
  .help-content p {
    font-size: 14px;
  }
  
  .important-notes ul,
  .help-section ul {
    padding-left: 0;
    margin-left: 15px;
  }
  
  .prize-details {
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Help.vue